import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'oval', 'Oval', [["path",{"d":"M12 12m-6 0a6 9 0 1 0 12 0a6 9 0 1 0 -12 0","key":"svg-0"}]]);